module.exports = __webpack_public_path__ + "img/binance_sign.00d2e116.svg";